import React from "react";
import TableCell from "@material-ui/core/TableCell";

const HoverActionCell = ({
  header,
  data,
  hoverButtonMsg,
  hoverButtonAction
}) => {
  return (
    <TableCell key={`hover-cell+${header}`} className="hover-cell">
      <strong>{data?.[header] ? data?.[header].toString() : ""}</strong>
      <button onClick={hoverButtonAction} className="hover-cell__button btn">
        {hoverButtonMsg}
      </button>
      <p>{data?.tag_description}</p>
    </TableCell>
  );
};

export default HoverActionCell;
